package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class MagicLinkRequest(
    val email: String,
    val locale: String? = null
)

@Serializable
data class VerifyMagicLinkRequest(
    val token: String
)

@Serializable
data class AuthUserDto(
    val id: String,
    val email: String
)

/** Deleting the account: the user types their email to confirm. */
@Serializable
data class AccountDeleteRequest(val confirmEmail: String)
